import  { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom';
import { fetchIconsData } from '../../features/Setting/Icons';

function Icon() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchIconsData());
  }, [dispatch]);
  const { settings } = useSelector((state) => state.icons);
  // const [isOpenSearch, setIsOpenSearch] = useState(false);

  return (
    <div className='lg:flex hidden gap-5'>

      {
        settings?.map((setting) => (
          <Link to={setting.value} key={setting.id}>
            <img
              className="w-7 h-7"
              src={process.env.REACT_APP_IMG_URL + setting.icon}
              alt={setting.type}
            />
          </Link>
        ))
      }
    </div>
  )
}

export function CalenderIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-calendar4" viewBox="0 0 16 16">
      <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5M2 2a1 1 0 0 0-1 1v1h14V3a1 1 0 0 0-1-1zm13 3H1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z" />
    </svg>
  )
}

export function ReadMoreIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5 transition-transform duration-300 group-hover/button:translate-x-1"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
        clipRule="evenodd"
      />
    </svg>
  )
}

export default Icon
